export default ({ color = "white", ...props }) => (
  <svg
    width="111"
    height="27"
    viewBox="0 0 111 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M103.758 8.5871C105.345 8.5871 106.468 9.21041 107.237 10.1393V3.14844H110.412V20.7477H107.298V19.44C106.529 20.3933 105.381 21.0533 103.758 21.0533C100.498 21.0533 98.0312 18.3767 98.0312 14.8202C98.0312 11.2637 100.498 8.5871 103.758 8.5871ZM104.344 11.557C102.476 11.557 101.291 13.0114 101.291 14.8202C101.291 16.629 102.476 18.0834 104.344 18.0834C106.163 18.0834 107.396 16.6901 107.396 14.8202C107.396 12.9503 106.163 11.557 104.344 11.557Z"
      fill={color}
    />
    <path
      d="M92.749 8.58594C95.4351 8.58594 97.352 10.4559 97.352 13.2057V20.7465H94.1653V14.2324C94.1653 12.5213 93.3106 11.5803 91.8577 11.5803C90.4902 11.5803 89.3547 12.4724 89.3547 14.2568V20.7465H86.168V8.9037H89.2692V10.297C90.1117 9.03814 91.4059 8.58594 92.749 8.58594Z"
      fill={color}
    />
    <path
      d="M92.749 8.58594C95.4351 8.58594 97.352 10.4559 97.352 13.2057V20.7465H94.1653V14.2324C94.1653 12.5213 93.3106 11.5803 91.8577 11.5803C90.4902 11.5803 89.3547 12.4724 89.3547 14.2568V20.7465H86.168V8.9037H89.2692V10.297C90.1117 9.03814 91.4059 8.58594 92.749 8.58594Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M85.3417 8.9037V20.7465H82.0757V19.4388C81.3065 20.3921 80.1588 21.0521 78.5349 21.0521C75.2749 21.0521 72.8086 18.3755 72.8086 14.819C72.8086 11.2625 75.2749 8.58594 78.5349 8.58594C80.1588 8.58594 81.2943 9.24591 82.0757 10.2114V8.9037H85.3417ZM79.121 11.5558C77.2529 11.5558 76.0686 13.0102 76.0686 14.819C76.0686 16.6278 77.2529 18.0822 79.121 18.0822C80.9402 18.0822 82.1734 16.6889 82.1734 14.819C82.1734 12.9491 80.9402 11.5558 79.121 11.5558Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M72.0266 3.14844V20.7477H68.8398V3.14844H72.0266Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.2952 8.58594C65.7017 8.58594 68.0338 11.1158 68.046 14.8068C68.046 15.1734 68.0216 15.6134 67.9849 15.8823H59.5969C59.9388 17.5933 61.1353 18.3389 62.6371 18.3389C63.6627 18.3389 64.7738 17.9233 65.6285 17.2023L67.4966 19.2555C66.1535 20.4899 64.4441 21.0521 62.454 21.0521C58.8277 21.0521 56.3125 18.5833 56.3125 14.8557C56.3125 11.1281 58.7544 8.58594 62.2952 8.58594ZM62.2708 11.3358C60.769 11.3358 59.8899 12.2402 59.6091 13.7068H64.8471C64.554 12.1913 63.6383 11.3358 62.2708 11.3358Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.2461 11.741H53.6973V20.7484H50.5106V11.741H48.4531V8.90558H50.5106L50.5054 7.4899C50.5054 4.71557 51.9827 2.89453 54.7421 2.89453C56.3538 2.89453 57.4771 3.35896 58.3806 3.95782L57.1108 6.43883C56.5247 6.12106 55.8288 5.86441 55.084 5.86441C54.1683 5.86441 53.6921 6.42661 53.6921 7.52656L53.6973 8.90558H58.7393C57.6368 9.5481 56.7788 10.5204 56.2461 11.741Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47.7518 8.9037V20.7465H44.4859V19.4388C43.7167 20.3921 42.569 21.0521 40.9451 21.0521C37.6851 21.0521 35.2188 18.3755 35.2188 14.819C35.2188 11.2625 37.6851 8.58594 40.9451 8.58594C42.569 8.58594 43.7045 9.24591 44.4859 10.2114V8.9037H47.7518ZM41.5311 11.5558C39.6631 11.5558 38.4787 13.0102 38.4787 14.819C38.4787 16.6278 39.6631 18.0822 41.5311 18.0822C43.3504 18.0822 44.5836 16.6889 44.5836 14.819C44.5836 12.9491 43.3504 11.5558 41.5311 11.5558Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.492 9.72596L33.4175 12.207C32.4774 11.7425 30.9756 11.2537 29.6447 11.2415C28.436 11.2415 27.8255 11.6692 27.8255 12.317C27.8255 13.0014 28.6802 13.1725 29.7546 13.3314L30.8047 13.4903C33.3687 13.8813 34.7972 15.0302 34.7972 17.0346C34.7972 19.4789 32.7948 21.0555 29.3639 21.0555C27.7523 21.0555 25.64 20.75 24.1016 19.6622L25.3592 17.2423C26.3726 17.9145 27.6057 18.4034 29.3883 18.4034C30.8657 18.4034 31.5739 17.9878 31.5739 17.2912C31.5739 16.7168 30.9756 16.399 29.6081 16.2035L28.6436 16.069C25.9086 15.6902 24.5533 14.4924 24.5533 12.4758C24.5533 10.0437 26.4336 8.60156 29.5471 8.60156C31.4396 8.60156 32.9169 8.95599 34.492 9.72596Z"
      fill={color}
    />
    <mask
      id="mask0_1986_1925"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="27"
    >
      <path
        d="M3.555 15.8634C3.3062 15.4303 3.39783 14.9245 3.68969 14.618C3.84996 14.4493 4.14414 14.276 4.79042 13.6953C10.0307 8.9876 8.14028 4.27171 2.58281 2.83171C1.64625 2.58904 1.21531 2.56071 0.773694 2.44898C0.281821 2.32461 -0.126773 1.77494 0.0365521 1.16315C0.179127 0.628588 0.676852 0.358202 1.10316 0.384573C5.25908 0.642374 14.35 1.73857 17.7405 7.63739C21.1313 13.5361 17.531 21.9919 15.6755 25.7357C15.4851 26.1198 15.0029 26.4175 14.4709 26.2742C13.8617 26.1104 13.592 25.4801 13.7306 24.99C13.8552 24.55 14.0462 24.161 14.3053 23.2251C15.8423 17.671 12.7214 13.6687 6.04238 15.873C5.21848 16.1449 4.92175 16.3139 4.69622 16.3692C4.28603 16.4699 3.80411 16.2966 3.555 15.8634Z"
        fill={color}
      />
    </mask>
    <g mask="url(#mask0_1986_1925)">
      <path
        d="M3.555 15.8634C3.3062 15.4303 3.39783 14.9245 3.68969 14.618C3.84996 14.4493 4.14414 14.276 4.79042 13.6953C10.0307 8.9876 8.14028 4.27171 2.58281 2.83171C1.64625 2.58904 1.21531 2.56071 0.773694 2.44898C0.281821 2.32461 -0.126773 1.77494 0.0365521 1.16315C0.179127 0.628588 0.676852 0.358202 1.10316 0.384573C5.25908 0.642374 14.35 1.73857 17.7405 7.63739C21.1313 13.5361 17.531 21.9919 15.6755 25.7357C15.4851 26.1198 15.0029 26.4175 14.4709 26.2742C13.8617 26.1104 13.592 25.4801 13.7306 24.99C13.8552 24.55 14.0462 24.161 14.3053 23.2251C15.8423 17.671 12.7214 13.6687 6.04238 15.873C5.21848 16.1449 4.92175 16.3139 4.69622 16.3692C4.28603 16.4699 3.80411 16.2966 3.555 15.8634Z"
        fill={color}
      />
    </g>
  </svg>
);
